import styled from 'styled-components';

const StyledContainer = styled.div`
    margin: 0;
    padding: 0;
    border: 0;
    display: inline-flex;
    flex-wrap: wrap;
    box-sizing: border-box;
`;

export default StyledContainer;
